import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    button: {
        height: 51,
        background: '#403DE3',
        borderRadius: 51 / 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontSize: '17px',
        fontWeight: '700',
        cursor: 'pointer',
        padding: '0 30px',
        border: 'none',
        outline: 'none',
        transition: 'all 0.3s ease',
        fontFamily: 'Muli',
        '&:hover': {
            background: '#3b51fc',
        },
        [theme.breakpoints.down('md')]: {
            height: 48,
            fontSize: '16px',
        },
    },
    buttonPulse: {
        animation: "$pulse-animation 2s infinite",
    },

    "@keyframes pulse-animation": {
        "0%": {
            boxShadow: "0 0 0 0 rgba(59, 82, 252, 0.9)",
        },
        "100%": {
            boxShadow: "0 0 0 14px rgba(59, 82, 252, 0)",
        },
    },
}));

export default useStyles;